import { get } from '../apiClient';
import type { ModuleConfiguration } from '@/types';

export const modulesApi = {
  list: () => get<ModuleConfiguration[]>('/modules'),

  get: (key: string) => get<ModuleConfiguration>(`/modules/${key}`),
};

// Query key factory
export const moduleKeys = {
  all: ['modules'] as const,
  lists: () => [...moduleKeys.all, 'list'] as const,
  details: () => [...moduleKeys.all, 'detail'] as const,
  detail: (key: string) => [...moduleKeys.details(), key] as const,
};
